// Make sure jQuery is imported *before* Select2
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

// Import Select2 and its CSS
// import 'select2/dist/css/select2.min.css';
import 'select2'; // extends jQuery

// Optional theme (only needed if you're using Bootstrap 5 theme)
// import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';

// Optional init function
export function initSelect2() {
    $(".select2-bootstrap-5").each(function () {
        $(this).select2({
            theme: "bootstrap-5",
            dropdownParent: $(this).parent(),
        });
    });
}

window.select2 = $.fn.select2;
window.initSelect2 = initSelect2;

document.addEventListener("DOMContentLoaded", function () {
    if (window.initSelect2) {
        window.initSelect2();
    }
});